import * as THREE from 'three';
import UtilSP from 'SATPROF_UTILS/UtilSP';
import DropinSupervisorBase from "SATPROF_LIBRARY/DropinSupervisor/dropin-supervisor-base";
import ThreeFontService from "SATPROF_LIBRARY/DropinSupervisor/services/three-font-service";
import {TextGeometry} from 'three/examples/jsm/geometries/TextGeometry';
export default class String3D_grp  extends THREE.Group {
   
    /*
    Creates a group with text.
    Text lies in the X-Y plane and is read from the +Z direction.
    Upper left corner of text line is at the origin; text will be all in the Y<0 region.

    y
    ^
    |
    |
    |-----------------------> x
     ABCDEFGHIJK

    Properties and methods:
    text
    color
    lineHeight
    justify  "left" "center"
    rotXdeg
    rotYdeg
    rotZdeg
    boundingBox r/o
    */

    public threeFontService:ThreeFontService;
    private configs:Array<any>;
    private text_g:TextGeometry;
    private text_m:THREE.Mesh;
    private _text:string = "ABCDEFGHIJK";
    private _color:string = "yellow";
    private _lineHeight:number = 100;
    private _justify:string = "left";
    private main_grp:THREE.Group;
    private lines_m:Array<THREE.Mesh>;

    constructor(){
        super();
        const supervisor = DropinSupervisorBase.singleton; // Needed for 3D text
        // get the service - this also casts the service to the right class
        // this way it should be accessible from anywhere
        this.threeFontService = supervisor.getService<ThreeFontService>("ThreeFontService");
        this.configs = [];
        this.configs[0] = this.threeFontService.getGeometryConfigObject();
        this.lines_m = [];
        this.lines_m[0] = new THREE.Mesh();
        
        this.text_g = this.threeFontService.createFontGeometry("ABCDEFG", this.configs[0]);

        this.main_grp = new THREE.Group();
        this.main_grp.add(this.lines_m[0]);
        this.add(this.main_grp);
        this.rebuild();

        /* These setter calls are for testing:
        this.text = "Hi there!"
        this.color = "lime";
        this.justify = "left";
        this.lineHeight = 300;
        this.rotYdeg = 30;
        */

    }
     private rebuild(){
        this.configs[0].size = this._lineHeight;
        this.configs[0].bevelEnabled = false;
        //this.configs[0].height = .1;
        this.configs[0].depth = .1;

        this.text_g.dispose();
        this.text_g = this.threeFontService.createFontGeometry(this.text, this.configs[0]);
        if (this._justify == "center"){
            this.text_g.center();
        }
    
        this.lines_m[0].geometry = this.text_g;
        this.lines_m[0].material = new THREE.MeshBasicMaterial({color:this._color});
        this.lines_m[0].position.y = -this._lineHeight;
    }   
 
    public set text(val:string){
        this._text = val;
        this.rebuild();
    }
    public get text(){
        return this._text;
    }
    public set color(val:string){
        this._color = val;
        this.rebuild();
    }
    public get color(){
        return this._color;
    }    
    public set justify(val:string){
        this._justify = val;
        this.rebuild();
    }
    public get justify(){
        return this._justify;
    }      
    public set lineHeight(val:number){
        this._lineHeight = val;
        this.rebuild();
    }
    public get lineHeight(){
        return this._lineHeight;
    }  
    public set rotXdeg(val:number){
        this.main_grp.rotation.x = UtilSP.radians(val);
    }
    public get rotXdeg(){
        return UtilSP.degrees(this.main_grp.rotation.x);
    }
    public set rotYdeg(val:number){
        this.main_grp.rotation.y = UtilSP.radians(val);
    } 
    public get rotYdeg(){
        return UtilSP.degrees(this.main_grp.rotation.y);
    }    
    public set rotZdeg(val:number){
        this.main_grp.rotation.z = UtilSP.radians(val);
    }  
    public get rotZdeg(){
        return UtilSP.degrees(this.main_grp.rotation.z);
    }  
    public get boundingBox(){
        this.text_g.computeBoundingBox();
        return this.text_g.boundingBox;
    }  
    public get boundingSphere(){
        this.text_g.computeBoundingSphere();
        return this.text_g.boundingSphere;
    }    
}


